const { useProjectContext } = require("@contexts/projects");

const getAppropriationLevelName = (level) => {
  const levelMap = {
    'step': 'etapa',
    'substep': 'subetapa',
    'service': 'serviço',
    'unit': 'unidade',
    'cell': 'célula'
  };
  return levelMap[level] || level;
};

const AppropriationLevelWarning = () => {
  const { activeProject } = useProjectContext()
  const { appropriation_level } = activeProject || {};
  const levelName = getAppropriationLevelName(appropriation_level);

  return (
    <div className="appropriation-warning">
      <div className="header">
        <span className="margin-right-8">⚠️</span>
        Nível de Apropriação Necessário
      </div>

      <p>
        Para adicionar um estouro / economia, estoque ou antecipação, você precisa ir ao nível de apropriação da obra.
      </p>

      <p className="level-reminder">
        O nível de apropriação da sua obra é: <strong>{levelName}</strong>
      </p>
    </div>
  );
};

export default AppropriationLevelWarning;
